import {apiMethods} from "../../controller/Request";
import {Config} from "../../controller/Global";


export const SettingsGet = (id, params = {}) => {
  const URL = Config['api']['crm']['settings']['url'] + id + '/';
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const SettingsList = (params = {}) => {
  const URL = Config['api']['crm']['settings']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const SettingsPost = (params = {}) => {
  const URL = Config['api']['crm']['settings']['url'];
  return apiMethods.post(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })

};

export const SettingsUpdate = (id, params = {}) => {
  const URL = Config['api']['crm']['settings']['url'] + id + '/';
  return apiMethods.patch(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })
};

export const AdditionsList = (params = {}) => {
  const URL = Config['api']['crm']['additions']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const ExclusionList = (params = {}) => {
  const URL = Config['api']['crm']['exclusion']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const NotesList = (params = {}) => {
  const URL = Config['api']['crm']['notes']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const UnderstandingList = (params = {}) => {
  const URL = Config['api']['crm']['understanding']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const PaymentTermList = (params = {}) => {
  const URL = Config['api']['crm']['payment_term']['url'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};



// WEBPACK FOOTER //
// ./src/models/crm/settings.jsx